import React from "react";
import AddNewTest from "./Post Contest/add_new_test";
const PostContest = () => {
  return <AddNewTest />;
};
export default PostContest;
